// kvのfade
$(function(){
	$('[data-fadeKv]').addClass('is-show')
	$('[data-fadeKv]').addClass('is-done')
})

//スクロール
if($('[data-scroll]').length){
	let _EffectH = 100;
	$(window).on('scroll load', function() {
		let _scTop = $(this).scrollTop();
		let _scBottom = _scTop + $(this).height();
		let _effectPos = _scBottom - _EffectH;
		$('[data-scroll]').each( function() {
			let _thisPos = $(this).offset().top;
			if ( _thisPos < _effectPos ) {
				$.when(
					$(this).addClass('is-show')
				).done(function() {
					$(this).delay(200).queue(function(){
						$(this).addClass('is-done')
					})
				});
			}
		});
	});
}
// fade
window.addEventListener("load", function() {
  window.addEventListener("scroll", function() {
    var _windowHeight = window.innerHeight;
    var _scroll = window.pageYOffset || document.documentElement.scrollTop;

    var fadeElements = document.querySelectorAll("[data-fade]");
    fadeElements.forEach(function(element) {
      var targetPosition = element.offsetTop;
      if (_scroll > targetPosition - _windowHeight + 100) {
        element.classList.add("is-show");
      }
    });
  });

  var _fadeElements = document.querySelectorAll("[data-fade-in]");

  _fadeElements.forEach(function(element) {
    element.classList.add("is-show");
  });
});
